<template>
    <div class="order-history-detail">
        <div class="box-header">
            <i class="el-icon-close" @click="$emit('close')"></i>
            <span>Order History Detail</span>
        </div>
        <div class="box-content">
            <scroll-wrap>
                <div class="product">
                    <div class="img">
                        <img :src="product.image" alt="">
                    </div>
                    <div class="cont">
                        <span class="title">{{product.title}}</span>
                        <span>Shipping:${{product.logistic}}</span>
                    </div>
                    <div class="price">
                        ${{product.status === 2 ? product.promotionPrice:product.price}}
                    </div>
                </div>
                <div class="viewOfDetail">
                    <el-collapse v-model="activeName" accordion>
                        <el-collapse-item name="1">
                            <div slot="title" class="tit">
                                Contact 
                            </div>
                            <div slot="default">

                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="2">
                            <div slot="title" class="tit">
                                View order details
                            </div>
                            <div slot="default">

                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="3">
                            <div slot="title" class="tit">
                                DeliverStatus
                            </div>
                            <div slot="default">

                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </scroll-wrap>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrderHistoryDetail",
        props:{
            productDetail:[Object]
        },
        data(){
            return {
                product:this.productDetail,
                activeName:''
            }
        },
        methods:{

        },
    }
</script>

<style scoped lang="scss">
.order-history-detail {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFFFFF;
    div.box-header {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 52px;
        line-height: 52px;

        > i {
            position: absolute;
            top: 50%;
            left: 0;
            font-weight: bolder;
            transform: translateY(-50%);
            font-size: 18px;
            padding: 10px;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }
        }

        > span {
            font-size: 18px;
            color: #000000;
            font-weight: bolder;
        }
    }
    div.box-content {
        position: relative;
        height: calc(100% - 104px);

        div.product {
            display: flex;
            justify-content: space-between;
            padding: 12px;
            div.img {
                width: 80px;
                height: 80px;
                flex-shrink: 0;
                margin-right: 12px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            div.cont {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                margin-right: 12px;
                > span {
                    font-size: 12px;
                    color: #adadad;
                    &.title {
                        font-size: 14px;
                        font-weight: bolder;
                        margin-bottom: 6px;
                        color: #000000;
                    }
                }
            }
            div.price {
                flex-shrink: 0;
            }

        }
        div.handlerProduct {
            padding: 12px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            span {
                padding: 12px;
                background: #089bab;
                color: #FFFFFF;
                border-radius: 6px;
                font-weight: bolder;
                margin-left: 12px;
                cursor: pointer;
                transition: opacity 0.3s linear;
                &:hover {
                    opacity: 0.8;
                    transition: opacity 0.3s linear;
                }
            }
        }

        div.viewOfDetail {
            .tit {
                padding: 12px;
                font-size: 16px;
            }
        }

        div.message-alert {
            width: 100%;
            padding: 20px 0;
            background: #FFFFFF;
            position: absolute;
            bottom: -300px;
            left: 0;
            z-index: 9999;
            transition: bottom 0.3s linear;
            border-radius: 0 0 22px 22px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &.active {
                bottom: -52px;
                transition: bottom 0.3s linear;
            }
            > .img {
                width: 80px;
                height: 80px;
                margin-bottom: 20px;
                > img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            > .txt {
                font-weight: bolder;
                margin-bottom: 10px;
            }
            > .price {
                font-weight: lighter;
                font-size: 12px;
            }
        }
    }
}
</style>
